import { render, staticRenderFns } from "./WorkshopAttendanceMain.vue?vue&type=template&id=5fcc07d6"
import script from "./WorkshopAttendanceMain.vue?vue&type=script&lang=js"
export * from "./WorkshopAttendanceMain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports